import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { realTimeService } from 'src/app/services/services/realtime.service';
import { finalize } from 'rxjs/operators';
import { AgentList } from 'src/app/app-models/realTimeModels';

export interface ChangeReservedAgentDialogResult {
  action: 'change' | 'remove' | 'cancel';
  agentId?: number;
  agentName?: string;
  secondsFromNow?: number;
}

type AgentRow = { id: number; name: string };
type DialogData = { requestIds: number[]; queueId: number };

@Component({
    selector: 'change-reserved-agent-dialog',
    templateUrl: './change-reserved-agent-dialog.component.html',
    styleUrls: ['./change-reserved-agent-dialog.component.scss'],
    standalone: false
})
export class ChangeReservedAgentDialogComponent implements OnInit {
  requestIds: number[] = [];

  // UI state (kept minimal, matches template)
  option: 'change' | 'remove' = 'change';
  agentQuery = '';
  loading = false;
  searched = false;

  agentList: AgentRow[] = [];
  selectedAgent?: AgentRow;

  errorKey?: string;

  private queueId!: number;

  constructor(
    public dialogRef: MatDialogRef<ChangeReservedAgentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private realTimeService: realTimeService
  ) {}

  ngOnInit(): void {
    this.requestIds = this.data?.requestIds ?? [];
    this.queueId = this.data?.queueId;
  }

  onSearchAgent(): void {
    const q = (this.agentQuery || '').trim();
    if (!q) return;

    this.loading = true;
    this.errorKey = undefined;

    this.realTimeService
      .GetAllAgentsForQueue(this.queueId, q)  // ✅ use queueId from parent
      .pipe(finalize(() => { this.loading = false; this.searched = true; }))
      .subscribe(
        (list: AgentList[] | null | undefined) => {
          // Map API model -> dialog row (be defensive with types)
          this.agentList = (list || []).map(a => {
            const id = Number(a.userId ?? (a as any).id);
            const first = (a.firstname ?? '').toString();
            const last  = (a.lastname  ?? '').toString(); // your interface had lastname:number
            const name  = (first + ' ' + last).trim() || (a.groupname ?? '').toString();
            const groupname = (a.groupname ?? '').toString();
            return { id, name, groupname };
          }).filter(x => !Number.isNaN(x.id));
        },
        _err => {
          this.errorKey = 'shared_err_genericServerError';
          this.agentList = [];
        }
      );
  }

  selectAgent(a: AgentRow): void {
    this.selectedAgent = a;
  }

  onSave(): void {
    if (this.option === 'remove') {
      this.dialogRef.close(<ChangeReservedAgentDialogResult>{ 
        action: 'remove',
        secondsFromNow: -1,
        agentId: null 
      });
      return;
    }
    if (!this.selectedAgent) return;
    this.dialogRef.close(<ChangeReservedAgentDialogResult>{
      action: 'change',
      secondsFromNow: -2,
      agentId: this.selectedAgent.id,
      agentName: this.selectedAgent.name
    });
  }

  closeDialog(): void {
    this.dialogRef.close(<ChangeReservedAgentDialogResult>{ action: 'cancel' });
  }
}
